<template>
  <div>
    <div class="sub-header">
      <div class="header">
        <div class="d-flex align-items-center align-items-center">
            <span v-on:click="goBack" class="back-icon cursor-pointer">
              <svg
                width="14"
                height="22"
                viewBox="0 0 14 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.8355 0.482461C12.2638 -0.0892057 11.3422 -0.0892057 10.7705 0.482461L1.0755 10.1775C0.620503 10.6325 0.620503 11.3675 1.0755 11.8225L10.7705 21.5175C11.3422 22.0891 12.2638 22.0891 12.8355 21.5175C13.4072 20.9458 13.4072 20.0241 12.8355 19.4525L4.38884 10.9941L12.8472 2.53579C13.4072 1.97579 13.4072 1.04246 12.8355 0.482461Z"
                  fill="#353535"
                ></path>
              </svg>
            </span>
            <i class="icon-hrvenue header-icon"></i>
            <h1 class="xxl">
              {{ interviewName }}
            </h1>
        </div>
        <div @mouseover="$refs.dropdownAddCandidate.show()" @mouseleave="$refs.dropdownAddCandidate.hide()" class="position-relative">
          <b-dropdown id="dropdown-left" :class="['add-candidate-area']" ref="dropdownAddCandidate">
            <template #button-content>
              <i class="icon-person-add" />
              <span>{{ resource['hrvenue.createcandidate.addCandidateTitle'] }}</span>
              <div class="position-absolute padding-2 w-100 cursor-pointer" style="top: 34px; height: 6px; z-index: 99999;">&nbsp;</div>
            </template>
            <b-dropdown-item @click="showAddCandidateModalHandler('one-by-one-modal')">{{ resource['addCandidateOnebyOne'] }} </b-dropdown-item>
            <b-dropdown-item @click="showAddCandidateModalHandler('excel-modal')">{{ resource['addCandidateExcel'] }} </b-dropdown-item>
            <b-dropdown-item @click="showAddCandidateModalHandler('ats-modal')">{{ resource['addCandidateAts'] }} </b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
    </div>
    <transition name="slide-fade" key="infoNewCandidate" id="infoNewCandidate">
      <div class="page-info" v-if="showInfoNewCandidate" id="infoNewCandidate">
        <div class="page-info__text">
          <i class="icon-info" />
          <span v-html="showInfoNewCandidateText"></span>
          <button
            v-if="showInfoNewCandidateButton"
            class="page-info__button"
            @click="() => {
              setAssignFilter({ id: -1 })
              searchText = '';
              searchTextTimeout = null;
              showMine = false;
              sortValue = null;
              statusValue = null;
              removeFilter('sort');
              removeFilter('status');
            }"
          >
            {{ resource['candidateListInfoButtonText'] }}
          </button>
        </div>
        <i class="icon-close" @click="showInfoNewCandidate = false"></i>
      </div>
    </transition>
    <transition name="slide-fade" key="infoDeleteCandidate" id="infoDeleteCandidate">
      <div class="page-info" v-if="showInfoDeleteCandidate" id="infoDeleteCandidate">
        <div class="page-info__text">
          <i class="icon-info" />
          <span v-html="showInfoDeleteCandidateText"></span>
        </div>
        <i class="icon-close" @click="showInfoDeleteCandidate = false"></i>
      </div>
    </transition>
    <div class="page-view">
      <b-container :class="{ 'prevent-scroll': isListEmpty && !loading }">
        <!-- <div class="interview-list-info" v-if="interviewType === 1 && tabIndex === 1">
          <div class="d-flex align-items-center" style="gap: 12px">
            <img
              src="/images/ai-info-brain.svg"
              loading="lazy"
              alt="analysis"
              width="33"
              height="36"
            />
            {{ resource["hrvenueInterviewCandidateListInfoText"] }}
          </div>
        </div> -->
        <b-row class="justify-content-center p-0 m-0">
          <b-col :class="{ 'col-12 p-0': true }">
            <div v-if="!showAddCandidateButton" class="interview-list-filters-area" @click="closeSelect">
              <div class="d-flex align-items-center gap-2">
                <multiselect
                  v-if="interviewType === 1"
                  ref="sortMultiselect"
                  v-model="sortValue"
                  label="title"
                  track-by="title"
                  :options="sortOptions"
                  :multiple="false"
                  :searchable="false"
                  :close-on-select="true"
                  :hide-selected="false"
                  :preselect-first="false"
                  @select="changeFilter('sort')"
                  @remove="removeFilter('sort')"
                >
                  <template #placeholder>
                    <span class="option__desc">
                      <span class="option__title">
                        <i class="icon-sort" />
                        <span>{{ resource['order.sortByText'] }}</span>
                      </span>
                    </span>
                  </template>
                  <template #singleLabel="props">
                    <span :class="`option__desc ${sortValue && 'selected-option'}`">
                      <span class="option__title">
                        <i class="icon-sort" />
                        <span>{{ props.option.title }}</span>
                      </span>
                    </span>
                  </template>
                </multiselect>
                <multiselect
                  v-if="interviewType === 1"
                  ref="statusMultiselect"
                  class="status-multiselect"
                  v-model="statusValue"
                  label="title"
                  track-by="title"
                  :options="statusOptions"
                  :multiple="false"
                  :searchable="false"
                  :close-on-select="true"
                  :hide-selected="false"
                  :preselect-first="false"
                  @select="changeFilter('status')"
                  @remove="removeFilter('status')"
                >
                  <template #placeholder>
                    <span class="option__desc">
                      <span class="option__title">
                        <span>{{ resource['orderStatusText'] }}</span>
                      </span>
                    </span>
                  </template>
                  <template #singleLabel="props">
                    <span :class="`option__desc ${statusValue && 'selected-option'}`">
                      <span class="option__title">
                        <span>{{ props.option.title }}</span>
                      </span>
                    </span>
                  </template>
                </multiselect>
                <Assignees v-if="interviewType === 1 && checkRemainingRight(18)" :assignedEvaluators="selectedAssigness" isFilterDropdown @addUser="setAssignFilter($event)" />
                <button v-if="interviewType === 1 && checkRemainingRight(18)" key="showMine" id="showMine" :class="`show-mine-button ${showMine ? 'active' : ''}`" @click="showMineFilter">
                  <span>{{ getShortName(currentUser.fullname) }}</span>
                </button>
                <div class="search-area">
                  <div class="search-area__icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path d="M13.3137 12.0598H12.6553L12.422 11.8348C13.422 10.6681 13.9387 9.07643 13.6553 7.38477C13.2637 5.0681 11.3303 3.2181 8.997 2.93477C5.47201 2.50143 2.50534 5.4681 2.93867 8.9931C3.22201 11.3264 5.07201 13.2598 7.38867 13.6514C9.08034 13.9348 10.672 13.4181 11.8387 12.4181L12.0637 12.6514V13.3098L15.6053 16.8514C15.947 17.1931 16.5053 17.1931 16.847 16.8514C17.1887 16.5098 17.1887 15.9514 16.847 15.6098L13.3137 12.0598ZM8.31367 12.0598C6.23867 12.0598 4.56367 10.3848 4.56367 8.30977C4.56367 6.23477 6.23867 4.55977 8.31367 4.55977C10.3887 4.55977 12.0637 6.23477 12.0637 8.30977C12.0637 10.3848 10.3887 12.0598 8.31367 12.0598Z" fill="#333333"/>
                    </svg>
                  </div>
                  <input
                    type="text"
                    id="search-candidates"
                    name="search-candidates"
                    class="search-area__input"
                    v-model="searchText"
                    @input="searchCandidate"
                    :placeholder="resource['candidates.searchPlaceholder']"
                  />
                </div>
              </div>
              <div class="d-flex align-items-center gap-2">
                <button v-if="showAssignInBulkButton" id="assignInBulk" :class="`assign-bulk-button`" v-b-tooltip.hover.bottom="{ customClass: 'assignees-tooltip' }" :title="resource['assignInBulkTooltip']" @click="showAssignInBulkModalHandler">
                  <i class="icon-user-manage"></i>
                  <span>{{ resource['assignInBulkText'] }}</span>
                </button>
                <button v-if="showScheduleBulkButton" id="schedule-resend" :class="`assign-bulk-button`" v-b-tooltip.hover.bottom="{ customClass: 'assignees-tooltip' }" :title="resource['scheduleResendTooltip']" @click="scheduleResendLink()">
                  <i class="icon-resend" />
                  <span>{{resource["interviewDetailScheduleResendText"]}}</span>
                </button>
                <b-button
                  v-if="showAnalyzeAllButton"
                  @click="buttonLoading ? {} : showModalHandler('analyze')"
                  name="editAdd"
                  class="gradient-border-button"
                >
                  <svg :class="{ 'pulse-animation': buttonLoading }" xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                    <path d="M9.63104 7.24138C9.46596 7.16635 9.33365 7.03404 9.25862 6.86896L8.18278 4.5021C7.91632 3.91591 7.08368 3.91591 6.81723 4.5021L5.74138 6.86896C5.66635 7.03404 5.53404 7.16635 5.36896 7.24138L3.0021 8.31723C2.41591 8.58368 2.41591 9.41632 3.0021 9.68278L5.36896 10.7586C5.53404 10.8337 5.66635 10.966 5.74138 11.131L6.81723 13.4979C7.08368 14.0841 7.91632 14.0841 8.18278 13.4979L9.25862 11.131C9.33365 10.966 9.46596 10.8337 9.63104 10.7586L11.9979 9.68278C12.5841 9.41632 12.5841 8.58368 11.9979 8.31723L9.63104 7.24138ZM8.48063 9.63436C8.32711 9.70408 8.20408 9.82711 8.13436 9.98063C7.88693 10.5255 7.11307 10.5255 6.86564 9.98063C6.79592 9.82711 6.67289 9.70408 6.51937 9.63436C5.97453 9.38693 5.97453 8.61307 6.51937 8.36564C6.67289 8.29592 6.79592 8.17289 6.86564 8.01937C7.11307 7.47453 7.88693 7.47453 8.13436 8.01937C8.20408 8.17289 8.32711 8.29592 8.48063 8.36564C9.02547 8.61307 9.02547 9.38693 8.48063 9.63436Z" fill="#FF8D06"/>
                    <path d="M12.4839 4.49773C12.7503 5.08393 13.583 5.08393 13.8494 4.49773L13.8836 4.42254C13.9587 4.25746 14.091 4.12516 14.256 4.05012L14.3312 4.01595C14.9174 3.74949 14.9174 2.91685 14.3312 2.6504L14.256 2.61622C14.091 2.54118 13.9587 2.40888 13.8836 2.2438L13.8494 2.16861C13.583 1.58241 12.7503 1.58241 12.4839 2.16861L12.4497 2.2438C12.3747 2.40888 12.2424 2.54118 12.0773 2.61622L12.0021 2.6504C11.4159 2.91685 11.4159 3.74949 12.0021 4.01595L12.0773 4.05012C12.2424 4.12516 12.3747 4.25746 12.4497 4.42254L12.4839 4.49773Z" fill="#FF8D06"/>
                  </svg>
                  <span>{{ resource["analyzeAllText"] }}</span>
                </b-button>
              </div>
            </div>
            <div v-if="loading">
              <vue-content-loading :height="150" :speed="1">
                <rect x="0" y="10" rx="4" ry="4" width="100%" height="40" />
                <rect x="0" y="55" rx="4" ry="4" width="100%" height="40" />
                <rect x="0" y="100" rx="4" ry="4" width="100%" height="40" />
              </vue-content-loading>
            </div>
            <div v-else-if="isListEmpty" class="no-result flex-column justify-content-center align-items-center">
              <div
                class="inner no-selected-candidate-list d-flex flex-column align-items-center justify-content-center"
              >
                <img :src="getNoResultImage" class="no-result-image" />
                <h1
                  class="mt-3 no-result-message"
                  v-html="getNoResultMessage.replace('&nbsp;', '')"
                ></h1>
                <div @mouseover="!isAddCandidateModalVisible && !rightModal && $refs.dropdownAddCandidateCenter.show()" @mouseleave="!isAddCandidateModalVisible && !rightModal && $refs.dropdownAddCandidateCenter.hide()" class="position-relative">
                  <b-dropdown v-if="showAddCandidateButton" id="dropdown-left" :class="['add-candidate-area']" ref="dropdownAddCandidateCenter">
                    <template #button-content>
                      <i class="icon-person-add" />
                      <span>{{ resource['hrvenue.createcandidate.addCandidateTitle'] }}</span>
                      <div class="position-absolute padding-2 w-100 cursor-pointer" style="top: 34px; height: 6px; z-index: 99999;">&nbsp;</div>
                    </template>
                    <b-dropdown-item @click="showAddCandidateModalHandler('one-by-one-modal')">{{ resource['addCandidateOnebyOne'] }} </b-dropdown-item>
                    <b-dropdown-item @click="showAddCandidateModalHandler('excel-modal')">{{ resource['addCandidateExcel'] }} </b-dropdown-item>
                    <b-dropdown-item @click="showAddCandidateModalHandler('ats-modal')">{{ resource['addCandidateAts'] }} </b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>
            </div>
            <div v-else>
              <!-- <div class="action-area" v-if="interviewType === 1 && tabIndex === 1">
                <div class="d-flex align-items-center" style="gap: 12px">
                  <b-button
                    v-if="!showCheckbox"
                    name="select-checkbox"
                    @click="handleSelect"
                    class="border-button border-button--checkbox"
                  >
                    {{ resource['label.SelectAll'] }}
                  </b-button>
                  <div v-if="showCheckbox" class="d-flex align-items-center">
                    <b-form-checkbox
                      v-if="showCheckbox"
                      :id="'select-all'"
                      v-model="selectAll"
                      class="checkbox-2 d-none d-md-block mr-2"
                      :disabled="false"
                      @change="selectAllPageData"
                    />
                    <span class="mr-3 select-text cursor-pointer" @click="selectAllPageData">{{ resource['labelSelectPage'] }} ({{ list.length || 0 }})</span>
                    <b-button
                      name="cancel-checkbox"
                      @click="removeAllSelected"
                      class="border-button border-button--checkbox"
                    >
                      {{ resource['label.Cancel'] }}
                    </b-button>
                  </div>
                </div>
                <div class="d-flex gap-2 align-items-center">
                  <span v-if="selectedCandidates.length" class="select-text--gray">{{ selectedCandidates.length + " " + resource["selectedCandidateText"] }}</span>
                  <b-button
                    name="editAdd"
                    @click="buttonLoading ? {} : showModalHandler('transcribe')"
                    class="border-button"
                  >
                    <svg :class="{ 'pulse-animation': buttonLoading }" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M9.13104 7.24138C8.96596 7.16635 8.83365 7.03404 8.75862 6.86896L7.68278 4.5021C7.41632 3.91591 6.58368 3.91591 6.31723 4.5021L5.24138 6.86896C5.16635 7.03404 5.03404 7.16635 4.86896 7.24138L2.5021 8.31723C1.91591 8.58368 1.91591 9.41632 2.5021 9.68278L4.86896 10.7586C5.03404 10.8337 5.16635 10.966 5.24138 11.131L6.31723 13.4979C6.58368 14.0841 7.41632 14.0841 7.68278 13.4979L8.75862 11.131C8.83365 10.966 8.96596 10.8337 9.13104 10.7586L11.4979 9.68278C12.0841 9.41632 12.0841 8.58368 11.4979 8.31723L9.13104 7.24138ZM7.98063 9.63436C7.82711 9.70408 7.70408 9.82711 7.63436 9.98063C7.38693 10.5255 6.61307 10.5255 6.36564 9.98063C6.29592 9.82711 6.17289 9.70408 6.01937 9.63436C5.47453 9.38693 5.47453 8.61307 6.01937 8.36564C6.17289 8.29592 6.29592 8.17289 6.36564 8.01937C6.61307 7.47453 7.38693 7.47453 7.63436 8.01937C7.70408 8.17289 7.82711 8.29592 7.98063 8.36564C8.52547 8.61307 8.52547 9.38693 7.98063 9.63436Z" fill="#FF8D06"/>
                      <path d="M11.9839 4.49773C12.2503 5.08393 13.083 5.08393 13.3494 4.49773L13.3836 4.42254C13.4587 4.25746 13.591 4.12516 13.756 4.05012L13.8312 4.01595C14.4174 3.74949 14.4174 2.91685 13.8312 2.6504L13.756 2.61622C13.591 2.54118 13.4587 2.40888 13.3836 2.2438L13.3494 2.16861C13.083 1.58241 12.2503 1.58241 11.9839 2.16861L11.9497 2.2438C11.8747 2.40888 11.7424 2.54118 11.5773 2.61622L11.5021 2.6504C10.9159 2.91685 10.9159 3.74949 11.5021 4.01595L11.5773 4.05012C11.7424 4.12516 11.8747 4.25746 11.9497 4.42254L11.9839 4.49773Z" fill="#FF8D06"/>
                    </svg>
                    {{ selectedCandidates.length ? resource["transcribeSelectedText"] : resource["transcribeAllText"] }}
                  </b-button>
                  <b-button
                    @click="buttonLoading ? {} : showModalHandler('analyze')"
                    name="editAdd"
                    class="bg-button"
                  >
                    <svg :class="{ 'pulse-animation': buttonLoading }" xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                      <path d="M9.63104 7.24138C9.46596 7.16635 9.33365 7.03404 9.25862 6.86896L8.18278 4.5021C7.91632 3.91591 7.08368 3.91591 6.81723 4.5021L5.74138 6.86896C5.66635 7.03404 5.53404 7.16635 5.36896 7.24138L3.0021 8.31723C2.41591 8.58368 2.41591 9.41632 3.0021 9.68278L5.36896 10.7586C5.53404 10.8337 5.66635 10.966 5.74138 11.131L6.81723 13.4979C7.08368 14.0841 7.91632 14.0841 8.18278 13.4979L9.25862 11.131C9.33365 10.966 9.46596 10.8337 9.63104 10.7586L11.9979 9.68278C12.5841 9.41632 12.5841 8.58368 11.9979 8.31723L9.63104 7.24138ZM8.48063 9.63436C8.32711 9.70408 8.20408 9.82711 8.13436 9.98063C7.88693 10.5255 7.11307 10.5255 6.86564 9.98063C6.79592 9.82711 6.67289 9.70408 6.51937 9.63436C5.97453 9.38693 5.97453 8.61307 6.51937 8.36564C6.67289 8.29592 6.79592 8.17289 6.86564 8.01937C7.11307 7.47453 7.88693 7.47453 8.13436 8.01937C8.20408 8.17289 8.32711 8.29592 8.48063 8.36564C9.02547 8.61307 9.02547 9.38693 8.48063 9.63436Z" fill="white"/>
                      <path d="M12.4839 4.49773C12.7503 5.08393 13.583 5.08393 13.8494 4.49773L13.8836 4.42254C13.9587 4.25746 14.091 4.12516 14.256 4.05012L14.3312 4.01595C14.9174 3.74949 14.9174 2.91685 14.3312 2.6504L14.256 2.61622C14.091 2.54118 13.9587 2.40888 13.8836 2.2438L13.8494 2.16861C13.583 1.58241 12.7503 1.58241 12.4839 2.16861L12.4497 2.2438C12.3747 2.40888 12.2424 2.54118 12.0773 2.61622L12.0021 2.6504C11.4159 2.91685 11.4159 3.74949 12.0021 4.01595L12.0773 4.05012C12.2424 4.12516 12.3747 4.25746 12.4497 4.42254L12.4839 4.49773Z" fill="white"/>
                    </svg>
                    {{ selectedCandidates.length ? resource["analyzeSelectedText"] : resource["analyzeAllText"] }}
                  </b-button>
                </div>
              </div> -->
              <div v-if="listLoading">
                <vue-content-loading :height="150" :speed="1">
                  <rect x="0" y="0" rx="4" ry="4" width="100%" height="50" />
                  <rect x="0" y="70" rx="4" ry="4" width="100%" height="50" />
                </vue-content-loading>
              </div>
              <div v-else>
                <div class="interview-list">
                  <!-- Header Bölümü -->
                  <header class="interview-list__header">
                    <div class="interview-list__column interview-list__column--name cursor-pointer" :class="orderName" @click="orderCandidates('orderName', 5)">
                      <h4>{{ resource['candidateListHeaderNameText']}}</h4>
                    </div>
                    <div class="interview-list__column interview-list__column--status" v-if="interviewType === 1">
                      <h4>{{ resource['candidateListHeaderStatusText']}}</h4>
                    </div>
                    <div class="interview-list__column interview-list__column--scheduling" v-if="interviewType === 1">
                      <h4>{{ resource['candidateListHeaderSchedulingText']}}</h4>
                    </div>
                    <div class="interview-list__column interview-list__column--counts" ref="countsColumn" v-if="interviewType === 1">
                      <h4 class="interview-list__count-title cursor-pointer" :class="checkRemainingRight(10) ? orderAIScore : {}" @click="checkRemainingRight(10) ? orderCandidates('orderAIScore', 2) : {}">{{ resource['candidateListHeaderAIScoreText']}}</h4>
                      <h4 class="interview-list__count-title cursor-pointer" :class="orderTeamScore" @click="orderCandidates('orderTeamScore', 3)">{{ resource['candidateListHeaderTeamScoreText']}}</h4>
                    </div>
                    <div class="interview-list__column interview-list__column--counts" ref="countsColumn" v-if="interviewType !== 1">
                      <h4 class="interview-list__count-title cursor-pointer">{{ resource['candidateListHeaderInPersonEvaluateText']}}</h4>
                    </div>
                    <div class="interview-list__column interview-list__column--assigness" v-if="interviewType === 1 && checkRemainingRight(18)">
                      <h4>{{ resource['candidateListHeaderAssigneesText']}}</h4>
                    </div>
                  </header>

                  <section class="interview-list__body">
                    <transition-group name="list" class="w-100" tag="div">
                      <card-item
                        v-for="(item, index) in list"
                        :key="item.id"
                        :item="item"
                        :tab="tabIndex"
                        :lastChild="index === list.length - 1"
                        :zIndex = "list.length - index"
                        :candidate-id="item.candidateId"
                        :interviewType="interviewType"
                        :showCheckbox="showCheckbox"
                        @itemSelected="itemSelected"
                        :countsColumnWidth="$refs.countsColumn ? $refs.countsColumn.offsetWidth : null"
                        @scheduleResendLink="scheduleResendLink"
                        @showModalHandler="showModalHandler"
                        @getCandidateListOfInterview="getCandidateListOfInterview"
                        :canAssignEvaluator="canAssignEvaluator"
                        :showAssignees="checkRemainingRight(18)"
                      />
                    </transition-group>
                  </section>
                </div>
                <step-pagination
                  v-show="isShowPagination || this.paginationCount.total > 0"
                  :step-total="paginationCount.total"
                  :step-data-count="paginationCount.currentItemSize"
                  :current-page-index="paginationCount.currentPageIndex"
                  @currentIndex="GetData"
                />
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
      <analyze-modal
        :showModal="showModal"
        :analyzeOneCandidate="analyzeOneCandidate"
        pageType="interview-detail"
        :rights="rights"
        :selectedCandidates="selectedCandidates"
        :interviewId="interviewId"
        @closeModalHandler="closeModalHandler"
      />
      <add-candidate-modal
        :interviewId="interviewId"
        @GetData="getDataWithPagination(1)"
        @removeFilter="removeFilter"
        :show-selection-screen="showSelectionScreen"
        @showAddCandidateModalHandler="showAddCandidateModalHandler"
      />

      <b-modal v-model="rightModal" id="modal-center" centered hide-footer modal-class="new-modal">
        <div slot="modal-header" class="d-flex justify-content-end w-100">
          <i class="icon-close custom-modal-close cursor-pointer" @click="rightModal = false" />
        </div>
        <div class="d-flex align-items-center justify-content-center flex-column w-100">
          <img src="/images/upgrade.svg" loading="lazy" alt="upgrade">
          <h2>{{rightPopupTitle}}</h2>
          <p>{{rightPopupDescription}}</p>
          <div class="w-100 d-flex justify-content-between gap-3">
            <b-button
              name="cancel"
              class="border-button-create"
              @click="rightModal = false"
            >
              {{ resource["upgradePopupCancel"] }}
            </b-button>
            <b-button
              name="upgrade"
              class="bg-button gap-2 d-flex align-items-center"
              @click="routePricing()"
            >
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
              <path d="M8.49956 11.6797L11.2662 13.3531C11.7729 13.6597 12.3929 13.2064 12.2596 12.6331L11.5262 9.4864L13.9729 7.3664C14.4196 6.97973 14.1796 6.2464 13.5929 6.19973L10.3729 5.9264L9.11289 2.95307C8.88623 2.41307 8.11289 2.41307 7.88623 2.95307L6.62623 5.91973L3.40623 6.19307C2.81956 6.23973 2.57956 6.97306 3.02623 7.35973L5.47289 9.47973L4.73956 12.6264C4.60623 13.1997 5.22623 13.6531 5.73289 13.3464L8.49956 11.6797Z" fill="white"/>
            </svg>
            {{rightPopupSubmit}}
            </b-button>
          </div>
        </div>
      </b-modal>
    <AssignInBulkModal :isOpen="showAssignInBulkModal" @close="closeAssignInBulkModal" :totalCandidateCount="tempTotalCandidateCount" :interviewId="interviewId" @showAssignBulkInfo="showAssignBulkInfo" :selectedStatus="selectedStatus" :searchText="searchText" :showMine="showMine" :selectedAssigness="selectedAssigness" :showUnassigned="showUnassigned" />
  </div>
</template>

<script>
import HrVenueService from '@/services/hrvenue.service';
import Multiselect from 'vue-multiselect';
import { mapActions, mapGetters } from 'vuex';
import ResourceManager from '@/services/resource.service';
import { languageItems } from '@/static/languageItems';
import { showNotification } from '../../static/helpers';
import signalRService from '../../composables/signalrService';
import AddCandidateModal from './AddCandidateModal.vue';
import Assignees from '../common/Assignees.vue';
import AssignInBulkModal from './AssignInBulkModal.vue';
import AnalyzeModal from '../common/AnalyzeModal.vue';

export default {
  name: 'InterviewDetailView',
  components: {
    StepPagination: () => import('../layout/StepPagination.vue'),
    CardItem: () => import('./interviewDetail/interviewCandidateCardItem.vue'),
    Multiselect,
    AddCandidateModal,
    Assignees,
    AssignInBulkModal,
    AnalyzeModal,
  },
  data() {
    return {
      loading: true,
      tabIndex: 0,
      interviewId: '',
      interviewName: '',
      list: [],
      sentCount: 0,
      completedCount: 0,
      unCompletedCount: 0,
      interview: {},
      candidateId: 0,
      paginationCount: {
        currentItemSize: 20,
        currentPageIndex: 1,
        total: 0,
        totalIndex: 0,
      },
      searchText: '',
      searchTextTimeout: null,
      interviewType: 1, // default
      showModal: false,
      rights: [],
      modalType: null,
      interviewTranscriptionStatus: null,
      interviewAnalyzeStatus: null,
      buttonLoading: false,
      listLoading: false,
      showCheckbox: false,
      selectAll: false,
      selectedCandidates: [],

      rightModal: false,
      rightModalReason: null,
      companyPackageInfo: {},
      companyTrialPackageIsExpired: null,
      bulkSendRight: null,
      showSelectionScreen: false,

      orderName: 'default',
      orderScheduling: 'default',
      orderAIScore: 'default',
      orderTeamScore: 'default',

      sortValue: null,
      sortOptions: [],
      statusValue: null,
      statusOptions: [],

      selectedAssigness: [],
      selectedOrder: 2,
      selectedSort: 4,
      selectedStatus: 0,
      showMine: false,
      showAssignInBulkModal: false,
      canAssignEvaluator: false,
      totalCandidateCount: 0,
      tempTotalCandidateCount: 0,
      showUnassigned: false,
      showInfoNewCandidate: false,
      showInfoNewCandidateText: '',
      showInfoNewCandidateButton: false,
      showInfoDeleteCandidate: false,
      showInfoDeleteCandidateText: '',
      analyzeOneCandidate: false,
      analyzeSelectedLanguage: null,
    };
  },
  async created() {
    this.setCurrentInterviewId();
    if (this.interviewId < 1) {
      const lang = this.$route.params.lang === 'en' ? '' : this.$route.params.lang;

      this.$router.push({
        name: 'HrVenueView',
        params: {
          lang,
        },
      });
    }
    this.rights = await this.getRights();

    await this.getCredit();
    await this.getCompanyPackageInfo();
    await this.getCompanyTrialPackageInfo();
    this.bulkSendRight = this.checkRemainingRight(8);

    const options = this.checkRemainingRight(10) ? [
      { id: 4, title: this.resource['order.lastCompletionText'] },
      { id: 1, title: this.resource['order.averageScoreText'] },
      { id: 2, title: this.resource['order.aiScoreText'] },
      { id: 3, title: this.resource['order.yourScoreText'] },
    ] : [
      { id: 4, title: this.resource['order.lastCompletionText'] },
      { id: 3, title: this.resource['order.yourScoreText'] },
    ];

    this.sortOptions = options;

    this.statusOptions = [
      { id: 0, title: this.resource.statusAllText },
      { id: 1, title: this.resource.statusCompletedText },
      { id: 2, title: this.resource.statusScheduledText },
      { id: 3, title: this.resource.statusSentText },
      { id: 4, title: this.resource.statusInCompleteText },
      { id: 5, title: this.resource.statusExpiredText },
    ];

    await this.GetData(1);
    if (this.$route.params && this.$route.params.showSelectionScreen) {
      this.openModalWithSelection();
    }
  },

  computed: {
    ...mapGetters('addCandidateModals', [
      'isAddCandidateModalVisible',
    ]),
    showScheduleBulkButton() {
      return this.interviewType === 1 && this.totalCandidateCount > 0 && (this.selectedStatus === 2 || this.selectedStatus === 3 || this.selectedStatus === 5);
    },
    showAssignInBulkButton() {
      return this.interviewType === 1 && this.totalCandidateCount > 0 && this.canAssignEvaluator && this.checkRemainingRight(18);
    },
    showAnalyzeAllButton() {
      return this.interviewType === 1 && this.list.length > 0 && !this.showScheduleBulkButton && this.selectedStatus !== 4;
    },
    isListEmpty() {
      return this.list.length === 0;
    },

    isShowPagination() {
      return !this.isListEmpty && !this.loading;
    },

    getNoResultImage() {
      if ((this.selectedStatus || this.showUnassigned || this.selectedAssigness.length || this.showMine || this.searchText.length > 0) && this.totalCandidateCount === 0) {
        return require('@/assets/hrVenue/no-candidate-in-this-status.svg');
      // eslint-disable-next-line no-else-return
      } else if (this.totalCandidateCount === 0) {
        return require('@/assets/hrVenue/no-candidate-found.svg');
      }
      return '';
    },
    getNoResultMessage() {
      if (this.selectedStatus && this.totalCandidateCount === 0) {
        return this.resource['hrVenue.interviewDetail.noCandidateInThisStatusMessage'];
      // eslint-disable-next-line no-else-return
      } else if (this.showUnassigned && this.totalCandidateCount === 0) {
        return this.resource['hrVenue.interviewDetail.showUnassignedMessage'];
      } else if (this.selectedAssigness.length && this.totalCandidateCount === 0) {
        return this.resource['hrVenue.interviewDetail.selectedAssignessMessage'];
      } else if (this.showMine && this.totalCandidateCount === 0) {
        return this.resource['hrVenue.interviewDetail.showMineMessage'];
      } else if (this.searchText?.length > 0 && this.totalCandidateCount === 0) {
        return this.resource['label.NoResult'];
      } else if (this.totalCandidateCount === 0) {
        return this.resource['hrVenue.interviewDetail.noCandidateFoundMessage'];
      }
      return '';
    },
    showAddCandidateButton() {
      if (!this.selectedStatus && !this.showUnassigned && !this.selectedAssigness.length && !this.showMine && this.totalCandidateCount === 0 && this.searchText.length === 0) {
        return true;
      }
      return false;
    },
    rightPopupTitle() {
      let reason = '';
      switch (this.rightModalReason) {
        case 1:
          reason = this.resource.upgradePopupNotEnoughCredit; // 'Yeterli Kredi yok'
          break;
        case 2:
          reason = this.resource.upgradePopupNotBulkSend; // 'Toplu gönderim yok';
          break;
        default:
          break;
      }

      return reason;
    },

    rightPopupDescription() {
      let message = '';
      if (this.companyPackageInfo === null) {
        if (this.companyTrialPackageIsExpired === null) {
          message = this.resource.companyTrialPackageNotStartDescription;
        } else if (this.companyTrialPackageIsExpired) {
          message = this.resource.companyTrialPackageExpiredDescription;
        } else {
          message = this.resource.companyTrialPackageExpiredNotRightDescription;
        }
      } else {
        message = this.resource.companyPackageNotRightDescription;
      }

      return message;
    },

    rightPopupSubmit() {
      if (this.companyPackageInfo === null && this.companyTrialPackageIsExpired === null) {
        return this.resource.upgradePopupStart;
      }
      return this.resource.upgradePopupSubmit;
    },
  },
  methods: {
    scheduleResendLink(candidate) {
      this.showAddCandidateModal({
        type: 'one-by-one-modal',
        data: {
          candidate: candidate || {
            name: '',
            surname: '',
            email: '',
          },
          scheduleResendModal: true,
          setDate: !!candidate, // if candidate is exists, it will be true
          bulkSchedule: !candidate,
          candidatesStatus: candidate ? 0 : this.selectedStatus,
        },
        interviewType: this.interviewType,
        interviewId: this.interviewId,
      });

      this.showSelectionScreen = false;
    },
    handleSelect() {
      this.showCheckbox = true;
      dataLayer.push({
        event: 'ga4_event',
        event_name: 'button_click',
        page_type: 'interview-detail',
        site_type: 'interview',
        event_parameters: {
          button_name: 'select',
        },
      });
    },

    closeModalHandler() {
      this.showModal = false;
      dataLayer.push({
        event: 'ga4_event',
        event_name: 'popup_click',
        page_type: 'interview-detail',
        site_type: 'interview',
        event_parameters: {
          label: 'not-now',
          popup_name: this.modalType === 'analyze' ? 'analyze-your-interviews' : 'transcribe-your-interviews',
        },
      });
    },
    ...mapActions('addCandidateModals', ['showAddCandidateModal', 'hideAddCandidateModal']),
    openModalWithSelection() {
      this.showSelectionScreen = true;
      this.showAddCandidateModal({});
    },
    showAddCandidateModalHandler(type) {
      if (type === 'one-by-one-modal' && this.creditCount === 0) {
        this.rightModal = true;
        this.rightModalReason = 1; // credit not enough
        this.hideAddCandidateModal();
        return false;
      }
      if (type === 'excel-modal' && (!this.bulkSendRight || this.bulkSendRight.totalUsableRight === 0)) {
        this.rightModal = true;
        this.rightModalReason = 2; // bulk send not enough
        this.hideAddCandidateModal();
        return false;
      }

      if (type === 'ats-modal' && (!this.bulkSendRight || this.bulkSendRight.totalUsableRight === 0)) {
        this.rightModal = true;
        this.rightModalReason = 2; // bulk send not enough
        this.hideAddCandidateModal();
        return false;
      }

      this.showAddCandidateModal({
        type,
        data: null,
        interviewType: this.interviewType,
        interviewId: this.interviewId,
      });

      const buttonName = {
        'one-by-one-modal': 'add-candidate/one-by-one',
        'excel-modal': 'add-candidate/with-excel',
        'ats-modal': 'add-candidate/with-ats',
      };

      dataLayer.push({
        event: 'ga4_event',
        event_name: 'button_click',
        page_type: 'interview-detail',
        site_type: 'interview',
        event_parameters: {
          button_name: buttonName[type],
        },
      });

      this.showSelectionScreen = false;
    },
    async getCredit() {
      const { totalUsableRight } = await HrVenueService.getCreditRight();
      this.creditCount = totalUsableRight >= 0 ? totalUsableRight : 0;
    },
    async getCompanyPackageInfo() {
      const response = await HrVenueService.getCompanyPackage();
      this.companyPackageInfo = response;
    },
    async getCompanyTrialPackageInfo() {
      const response = await HrVenueService.getCompanyTrialPackageInfo();
      this.companyTrialPackageIsExpired = response.trialPackageIsExpired;
    },

    showModalHandler(type, candidate) {
      if (candidate) {
        this.selectedCandidates.push(candidate);
        this.analyzeOneCandidate = true;
      } else {
        this.selectedCandidates = [];
        this.analyzeOneCandidate = false;
      }
      this.modalType = type;
      this.showModal = true;
      if (type === 'transcribe') {
        dataLayer.push({
          event: 'ga4_event',
          event_name: 'button_click',
          page_type: 'interview-detail',
          site_type: 'interview',
          event_parameters: {
            button_name: this.selectedCandidates.length ? 'transcribe-selected' : 'transcribe-all',
          },
        });
        dataLayer.push({
          event: 'ga4_event',
          event_name: 'popup_view',
          page_type: 'interview-detail',
          site_type: 'interview',
          event_parameters: {
            popup_name: 'transcribe-your-interviews',
          },
        });
      } else if (type === 'analyze') {
        if (!this.selectedCandidates.length) {
          dataLayer.push({
            event: 'ga4_event',
            event_name: 'button_click',
            page_type: 'interview-detail',
            site_type: 'interview',
            event_parameters: {
              button_name: 'analyze-all',
            },
          });
        }
        dataLayer.push({
          event: 'ga4_event',
          event_name: 'popup_view',
          page_type: 'interview-detail',
          site_type: 'interview',
          event_parameters: {
            popup_name: 'analyze-your-interviews',
          },
        });
      }
    },
    async getRights() {
      const response = await HrVenueService.getRights([3, 4, 10, 8, 18]);
      return response;
    },

    orderCandidates(type, enumType) {
      this.sortValue = null;

      // set class names for icon
      const orderTypes = {
        orderName: ['orderAIScore', 'orderTeamScore'],
        orderAIScore: ['orderName', 'orderTeamScore'],
        orderTeamScore: ['orderName', 'orderAIScore'],
      };
      const currentState = this[type];
      // eslint-disable-next-line no-nested-ternary
      const newState = (currentState === 'default' ? 'desc' : (currentState === 'desc' ? 'asc' : 'default'));
      this[type] = newState;
      orderTypes[type].forEach((orderType) => {
        this[orderType] = 'default';
      });

      // set selectedSort and selectedOrder for API
      this.selectedSort = enumType;
      // eslint-disable-next-line no-nested-ternary
      this.selectedOrder = (newState === 'default' ? 0 : (newState === 'asc' ? 1 : 2));
      if (this.selectedOrder === 0) {
        this.selectedSort = 4;
      }
      this.getCandidateListOfInterview();
    },
    closeSelect(event) {
      const refs = ['sortMultiselect', 'statusMultiselect', 'assignessMultiselect'];
      refs.forEach((ref) => {
        if (this.$refs[ref] && !this.$refs[ref].$el.contains(event.target)) {
          this.$refs[ref].deactivate();
        }
      });
    },

    customLabel ({ title }) {
      return `${title}`;
    },

    setAssignFilter(user) {
      this.showMine = false;
      if (user.id === -1) {
        this.showUnassigned = !this.showUnassigned;
      }
      const isExist = this.selectedAssigness.some((item) => item === user.id);
      if (isExist) {
        this.selectedAssigness = this.selectedAssigness.filter((item) => item !== user.id);
      } else {
        this.selectedAssigness.push(user.id);
      }

      this.getCandidateListOfInterview();
    },

    showMineFilter() {
      this.showMine = !this.showMine;
      this.selectedAssigness = [];
      this.showUnassigned = false;
      this.selectedStatus = 0;
      this.getCandidateListOfInterview();
    },

    showAssignInBulkModalHandler() {
      this.showAssignInBulkModal = true;
      dataLayer.push({
        event: 'ga4_event',
        event_name: 'button_click',
        page_type: 'interview-detail',
        site_type: 'interview',
        event_parameters: {
          button_name: 'assign-in-bulk',
        },
      });
    },
    closeAssignInBulkModal() {
      this.showAssignInBulkModal = false;
    },

    changeFilter(type) {
      if (type === 'status') {
        this.selectedStatus = this.statusValue?.id;
      } else if (type === 'sort') {
        this.orderName = 'default';
        this.orderScheduling = 'default';
        this.orderAIScore = 'default';
        this.orderTeamScore = 'default';
        this.selectedSort = this.sortValue?.id;
      }

      this.getCandidateListOfInterview();
    },

    removeFilter(type) {
      if (type === 'sort') {
        this.selectedSort = 4;
      } else if (type === 'status') {
        this.selectedStatus = 0;
        this.statusValue = null;
      }
      this.GetData(1);
    },

    selectAllPageData() {
      const currentPageIndex = this.paginationCount.currentPageIndex;

      if (this.list.every((item) => item.isSelected)) {
        this.selectedCandidates = this.selectedCandidates.filter(
          (iterator) => iterator.page !== currentPageIndex,
        );

        this.list.forEach((item) => {
          item.isSelected = false;
        });

        this.selectAll = false;
      } else {
        this.selectAll = true;

        this.list.forEach((item) => {
          item.isSelected = true;

          const alreadySelected = this.selectedCandidates.some(
            (candidate) => candidate.id === item.id
                     && candidate.page === currentPageIndex,
          );

          if (!alreadySelected) {
            this.selectedCandidates.push({
              ...item,
              page: currentPageIndex,
            });
          }
        });
      }
    },

    itemSelected(item) {
      const currentPageIndex = this.paginationCount.currentPageIndex;

      const alreadySelected = this.selectedCandidates.some(
        (candidate) => candidate.id === item.id
      && candidate.page === currentPageIndex,
      );

      if (!alreadySelected) {
        this.selectedCandidates.push({
          ...item,
          page: currentPageIndex,
        });
      } else {
        // ID ve page’e göre filtreleme yapıyoruz
        this.selectedCandidates = this.selectedCandidates.filter(
          (iterator) => !(iterator.id === item.id
          && iterator.page === currentPageIndex),
        );
      }

      this.selectAll = this.list.every((item) => item.isSelected);
    },

    checkRemainingRight(type) {
      const right = this.rights?.find((item) => item.companyRightType === type);
      return right?.totalUsableRight > 0;
    },
    routePricing() {
      dataLayer.push({
        event: 'ga4_event',
        event_name: 'popup_click',
        page_type: 'interview-detail',
        site_type: 'interview',
        event_parameters: {
          label: 'upgrade-plan',
          popup_name: this.modalType === 'analyze' ? 'analyze-your-interviews' : 'transcribe-your-interviews',
        },
      });
      const lang = this.$route.params.lang === 'en' ? '' : this.$route.params.lang;

      this.$router.push({ name: 'PricingListView', params: { lang } });
    },
    setCurrentInterviewId() {
      this.interviewId = this.$route.params.interviewId;
      this.interviewName = this.$route.params.name;
      this.interviewType = this.$route.params.type;
      this.interviewTranscriptionStatus = this.$route.params.transcriptionStatus;
      this.interviewAnalyzeStatus = this.$route.params.analyzeStatus;
    },
    async GetData(newIndex) {
      if (newIndex !== 1 && this.paginationCount.currentPageIndex === newIndex) {
        return;
      }
      this.loading = true;
      this.listLoading = true;
      await this.getDataWithPagination(newIndex);
      this.loading = false;
      this.listLoading = false;
    },
    async getDataWithPagination(newIndex) {
      this.selectAll = false;
      this.paginationCount.currentPageIndex = newIndex;
      await this.getCandidateListOfInterview();
    },
    async getCandidateListOfInterview() {
      try {
        const response = await HrVenueService.getCandidateListOfInterview(
          this.interviewId,
          this.selectedStatus, // status - isSuccesful eski adı // selectedStatus,
          this.paginationCount.currentPageIndex,
          this.paginationCount.currentItemSize,
          this.searchText,
          this.selectedSort,
          this.selectedOrder,
          this.showMine,
          this.selectedAssigness.filter((item) => item !== -1),
          this.showUnassigned,
        );

        if (response.body?.errorCode) {
          const lang = this.$route.params.lang === 'en' ? '' : this.$route.params.lang;

          this.$router.push({
            name: 'HrVenueView',
            params: {
              lang,
            },
          });
        }

        this.sentCount = response.sentCount;
        this.unCompletedCount = response.unCompletedCount;
        this.completedCount = response.completedCount;
        this.interviewName = response.interviewName || this.$route.params.name;
        this.interviewType = this.$route.params.type ?? response.interviewType;
        if (response.items && response.items.length > 0) {
          const logIds = response.items.map((item) => item.id);
          let evaluatorsMap = {};
          if (logIds.length > 0) {
            const evaluatorsResponse = await HrVenueService.getInterviewCandidateEvaluators(logIds);
            evaluatorsMap = evaluatorsResponse?.candidateAssignments?.reduce((acc, curr) => {
              acc[curr.interviewCandidateLogId] = curr.assignments;
              return acc;
            }, {}) || [];
          }
          this.list = response.items.map((item) => {
            const isSelected = this.selectedCandidates.some(
              (iterator) => iterator.Id === item.Id,
            );
            item.isSelected = isSelected;
            item.assignedEvaluators = evaluatorsMap[item.id] || [];
            return item;
          });
        } else {
          this.list = [];
        }
        this.canAssignEvaluator = response.canAssignEvaluator;
        this.tempTotalCandidateCount = this.totalCandidateCount === 0 || !this.showAssignInBulkModal ? response.totalCount : this.tempTotalCandidateCount;
        this.totalCandidateCount = response.totalCount;
        this.selectAll = this.list.every((item) => item.isSelected);
        this.paginationCount.total = +response.totalCount;
        this.paginationCount.totalIndex = +Math.floor(
          this.paginationCount.total / this.list.length,
        );

        let currentLanguage = null;
        if (typeof ResourceManager.CurrentLang !== 'string') {
          currentLanguage = ResourceManager.CurrentLang.id;
        } else {
          currentLanguage = languageItems.find(
            (item) => item.code === ResourceManager.CurrentLang,
          )?.id;
        }
        this.analyzeSelectedLanguage = currentLanguage;
      } catch (error) {
        showNotification(this.resource['label.Error'], error);
        const lang = this.$route.params.lang === 'en' ? '' : this.$route.params.lang;

        this.$router.push({
          name: 'HrVenueView',
          params: {
            lang,
          },
        });
      }
    },
    goBack() {
      const lang = this.$route.params.lang === 'en' ? '' : this.$route.params.lang;

      this.$router.push({
        name: 'HrVenueView',
        params: {
          lang,
        },
      });
    },
    async searchCandidate() {
      this.paginationCount.currentPageIndex = 1;
      clearTimeout(this.searchTextTimeout);
      this.searchTextTimeout = setTimeout(async () => {
        if (this.searchText === '' || this.searchText.length > 2) {
          await this.GetData(this.paginationCount.currentPageIndex);
        }
      }, 500);
    },
    // TODO: bunu sildik ama apideki isteğe göre direk başlatmamız gerekebilir o durumda geri eklenecek
    getShortName(fullName) {
      let initials = '';

      if (fullName) {
        const nameParts = fullName.trim().split(' ');
        if (nameParts[0]) initials += nameParts[0].charAt(0).toUpperCase();
        if (nameParts[1]) initials += nameParts[1].charAt(0).toUpperCase();
      }

      return initials;
    },
    async showAssignBulkInfo() {
      const response = await HrVenueService.getTotalUnassignedCandidateCount(this.interviewId);
      if (response > 0) {
        this.showInfoNewCandidate = true;
        this.showInfoNewCandidateText = this.resource.candidateListNewCandidateNotification.replace('{totalCandidateCount}', response);
        this.showInfoNewCandidateButton = true;
      }
    },
  },
  mounted() {
    document.addEventListener('click', this.closeSelect);

    signalRService.addEventListener('RefreshInterviewCandidatesList', async (data) => {
      if (data === this.interviewId) {
        await this.getDataWithPagination(this.paginationCount.currentPageIndex, false);
      }
    });

    signalRService.addEventListener('RefreshBlaBla', async (data) => {
      if (data === this.interviewId) {
        await this.getDataWithPagination(this.paginationCount.currentPageIndex, false);
      }
    });

    signalRService.addEventListener('DeleteInterviewCandidate', async (data) => {
      if (data.interviewId === this.interviewId) {
        // zaten info mesajı açıksa, mesajda ki aday sayısını güncelle
        if (this.showInfoDeleteCandidate || data.userId !== this.currentUser.userId) {
          const response = await HrVenueService.getTotalUnassignedCandidateCount(this.interviewId);
          this.showInfoDeleteCandidate = true;
          this.showInfoDeleteCandidateText = this.resource.candidateListDeleteCandidateNotification.replace('{totalCandidateCount}', response);
        }
      }
    });
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeSelect);

    signalRService.removeEventListener('RefreshInterviewCandidatesList');
    signalRService.removeEventListener('RefreshBlaBla');
    signalRService.removeEventListener('DeleteInterviewCandidate');
  },
};
</script>

<style lang="scss" scoped>
@import "~@/style/starter.scss";
.nocursor {
  cursor: text !important;
}
.back-icon {
  display: flex;
  align-items: center;
  margin-right: 20px;
}
.no-result {
  display: flex;
  justify-content: center;
  height: 85vh;
  min-height: 100px;
  text-align: center;

  .inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .no-result-image {
    margin-bottom: 4px;
    display: block;
  }

  .no-result-message {
    text-align: center;
    margin: 0px !important;
    color: #353535;
    font-family: Roboto;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    margin-bottom: 16px !important;
  }
}

.page-view {
  padding-top: 0 !important;
  background: #FAFAFA !important;

  .container {
    width: 100%;
    max-width: 100% !important;
    padding: 16px;
    min-height: calc(100vh - 90px);

    // Sadece no-result durumunda scroll'u engelle
    &.prevent-scroll {
      height: calc(100vh - 90px);
      overflow: hidden;
    }
  }
}

.candidate-card-item {
  background: #fff;
  margin-bottom: 8px;
  border-radius: 8px;
  border: 1px solid #e5e5e5;
}

.list-enter-active, .list-leave-active {
  transition: all 1s;
}
.list-enter, .list-leave-to {
  opacity: 0;
  transform: translateY(30px);
}

.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

.page-info {
  display: flex;
  padding: var(--Padding-Regular, 8px) var(--Padding-Large, 16px);
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-top: 1px solid #B7E1F3;
  border-bottom: 1px solid #B7E1F3;
  background: #DBF0F9;
  width: calc(100% - 248px);
  position: relative;
  top: 0;
  left: 248px;
  transition: all 0.3s ease-in-out;

  @media only screen and (max-width: 1150px) {
    width: 100%;
  }

  &__text {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }

  span {
    color: #114E67;
    font-feature-settings: 'liga' off, 'clig' off;
    /* Typography/Small Text/1 - Medium */
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
  }

  i {
    color: #114E67;
    font-size: 20px;
  }

  .icon-close {
    position: absolute;
    right: 16px;
    cursor: pointer;
  }

  &__button {
    background: transparent;
    color: var(--Text-Colors-Blue-Text, #114E67);
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 18px;
    padding: 0;
  }
}

.interview-list-filters-area {
  width: 100%;
  display: flex;
  margin-bottom: 16px;
  gap: 8px;
  align-items: center;
  justify-content: space-between;

  @media only screen and (max-width: 1150px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 0;
    gap: 8px;

    div:first-child {
      flex-direction: column;
      align-items: flex-start !important;
    }
  }

  .search-area {
    display: flex;
    align-self: center;
    position: relative;
    width: fit-content;
    width: 240px;
    border-radius: 4px;
    border: 1px solid var(--Stroke-Colors-Primary-Gray-Stroke, #E5E5E5);
    background: var(--Background-Colors-White, #FFF);
    height: 32px;

    &:has(.search-area__input:focus) {
      border-color: #ff8d06 !important;
      box-shadow: 0px 0px 0px 4px rgba(255, 141, 6, 0.3) !important;
    }

    &__icon {
      position: absolute;
      width: 1.0625rem;
      height: 1.0625rem;
      right: 8px;
      top: 5px;
    }
    &__input {
      font-family: 'Roboto';
      font-size: 0.875rem;
      font-style: normal;
      font-weight: 400;
      line-height: 1.125rem;
      border: 0;
      padding: 8px;
      width: calc(100% - 16px);
      background: transparent;

      &:focus {
        outline: none;
      }
    }
  }
}

::v-deep .interview-list {
  min-height: 60vh;
  width: 100%;

  @include media-breakpoint-down(md) {
    min-height: auto;
  }

  // Header (Liste Başlığı)
  &__header {
    display: flex;
    width: 100%;
    padding: var(--Padding-Small, 4px) var(--Padding-Medium, 12px) var(--Padding-Small, 4px) var(--Padding-Large, 16px);
    align-items: flex-end;
    gap: var(--Padding-4XLarge, 48px);
    border-radius: 8px 8px 0 0;
    border: 1px solid var(--Stroke-Colors-Primary-Gray-Stroke, #E5E5E5);
    background: var(--Background-Colors-Primary-Gray, #EEE);

    @media only screen and (max-width: 1150px) {
      display: none;
    }

    h4 {
      color: var(--Text-Colors-Primary-Gray-Text, #333);
      font-feature-settings: 'liga' off, 'clig' off;
      font-family: Roboto;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
    }

    .interview-list__column--name {
      padding-left: 49px;
    }
  }

  // Liste Gövdesi
  &__body {
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px solid #E5E5E5;
    border-top: 0;
    border-radius: 0 0 8px 8px;
    margin-bottom: 32px;

    @media only screen and (max-width: 1150px) {
      .interview-list__column {
        width: 100% !important;
      }
      .interview-list__column--counts .interview-list__count {
        justify-content: flex-start;
      }
    }
  }

  // Sütunlar (Columns)
  &__column {
    &--name {
      display: flex;
      align-items: center;
      gap: var(--Padding-XSmall, 2px);
      flex-shrink: 0;
      width: 240px;
      justify-content: flex-start;
      position: relative;

      .name-details {
        display: flex;
        align-items: flex-start;
        flex-direction: column;

        p {
          color: #333;
          font-feature-settings: 'liga' off, 'clig' off;
          font-family: Roboto;
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
          line-height: 20px;
          overflow-wrap: anywhere;
        }

        span {
          color: #333;
          font-feature-settings: 'liga' off, 'clig' off;
          font-family: Roboto;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 4px;
          overflow-wrap: anywhere;
        }

        i {
          visibility: hidden;
          font-size: 12px;
        }

        .green-icon {
          color: #49CA77;
          display: block !important;
        }

      }

      &:hover {
        .name-details {
          i {
            visibility: visible;
            cursor: pointer;
            text-decoration: none;
          }
          span {
            text-decoration: underline;
          }
        }
      }

      &.asc {
        h4 {
          &::after {
            top: 2px;
            position: absolute;
            content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M7.23876 5.79898V10.2581C7.23876 10.6661 6.90489 11 6.49682 11C6.08875 11 5.75488 10.6661 5.75488 10.2581V5.79898H4.4268C4.09292 5.79898 3.9297 5.39833 4.16712 5.16833L6.23714 3.10573C6.38553 2.96476 6.61553 2.96476 6.76392 3.10573L8.83394 5.16833C9.07136 5.39833 8.90071 5.79898 8.57426 5.79898H7.23876Z" fill="%23333333"/></svg>');
          }
        }
      }
      &.desc {
        h4 {
          &::after {
            top: 2px;
            position: absolute;
            content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M7.23876 8.20102V3.74194C7.23876 3.33387 6.90489 3 6.49682 3C6.08875 3 5.75488 3.33387 5.75488 3.74194V8.20102H4.4268C4.09292 8.20102 3.9297 8.60167 4.16712 8.83167L6.23714 10.8943C6.38553 11.0352 6.61553 11.0352 6.76392 10.8943L8.83394 8.83167C9.07136 8.60167 8.90071 8.20102 8.57426 8.20102H7.23876Z" fill="%23333333"/></svg>');
          }
        }
      }

      &:hover {
        &.default {
          h4 {
            &::after {
              top: 2px;
              position: absolute;
              content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M5.04402 1.95617L3.41652 3.58367C3.22985 3.76451 3.35819 4.0795 3.62069 4.0795H4.66485V7.58534C4.66485 7.90617 4.92735 8.16867 5.24819 8.16867C5.56902 8.16867 5.83152 7.90617 5.83152 7.58534V4.0795H6.87569C7.13819 4.0795 7.26652 3.76451 7.07985 3.58367L5.45235 1.95617C5.34152 1.84534 5.15485 1.84534 5.04402 1.95617ZM9.33152 9.92451V6.41867C9.33152 6.09784 9.06902 5.83534 8.74819 5.83534C8.42735 5.83534 8.16485 6.09784 8.16485 6.41867V9.92451H7.12069C6.85819 9.92451 6.72985 10.2395 6.91652 10.4203L8.54402 12.042C8.66069 12.1528 8.84152 12.1528 8.95819 12.042L10.5857 10.4203C10.7724 10.2395 10.6382 9.92451 10.3815 9.92451H9.33152Z" fill="%23333333"/></svg>');
            }
          }
        }
      }
    }

    &--counts {
      display: flex;
      align-items: center;
      gap: var(--Padding-XLarge, 24px);

      @media only screen and (max-width: 1150px) {
        flex-direction: column;
        align-items: flex-start;
        padding: 0;
        gap: 8px;
      }
    }

    &--status {
      display: flex;
      width: 93px;
      padding: 0;
      align-items: center;
      gap: var(--Padding-XSmall, 2px);
      flex-shrink: 0;

      p {
        font-feature-settings: 'liga' off, 'clig' off;
        font-family: Roboto;
        font-size: 12px;
        font-weight: 500;
        line-height: 18px;
      }

      i {
        font-size: 14px;
      }
    }

    &--scheduling {
      display: flex;
      width: 80px;
      align-items: center;
      gap: 2px;
      flex-shrink: 0;
      flex-direction: column;
      position: relative;

      @media only screen and (max-width: 1150px) {
        align-items: flex-start;
      }

      span {
        color: #333;
        font-family: Roboto;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px;
      }
    }

    &--assigness {
      display: flex;
      min-width: 98px;
      padding: 0;
      align-items: center;
      gap: var(--Padding-XSmall, 2px);
      flex-shrink: 0;
      position: relative;

      h4 {
        cursor: pointer;
      }
    }
  }

  &__count-title {
    min-width: 98px;
    flex: 1 1 auto;
    position: relative;

    &.asc {
      &::after {
        top: 2px;
        position: absolute;
        content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M7.23876 5.79898V10.2581C7.23876 10.6661 6.90489 11 6.49682 11C6.08875 11 5.75488 10.6661 5.75488 10.2581V5.79898H4.4268C4.09292 5.79898 3.9297 5.39833 4.16712 5.16833L6.23714 3.10573C6.38553 2.96476 6.61553 2.96476 6.76392 3.10573L8.83394 5.16833C9.07136 5.39833 8.90071 5.79898 8.57426 5.79898H7.23876Z" fill="%23333333"/></svg>');
      }
    }
    &.desc {
      &::after {
        top: 2px;
        position: absolute;
        content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M7.23876 8.20102V3.74194C7.23876 3.33387 6.90489 3 6.49682 3C6.08875 3 5.75488 3.33387 5.75488 3.74194V8.20102H4.4268C4.09292 8.20102 3.9297 8.60167 4.16712 8.83167L6.23714 10.8943C6.38553 11.0352 6.61553 11.0352 6.76392 10.8943L8.83394 8.83167C9.07136 8.60167 8.90071 8.20102 8.57426 8.20102H7.23876Z" fill="%23333333"/></svg>');
      }
    }

    &:hover {
      &.default {
        &::after {
          top: 2px;
          position: absolute;
          content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M5.04402 1.95617L3.41652 3.58367C3.22985 3.76451 3.35819 4.0795 3.62069 4.0795H4.66485V7.58534C4.66485 7.90617 4.92735 8.16867 5.24819 8.16867C5.56902 8.16867 5.83152 7.90617 5.83152 7.58534V4.0795H6.87569C7.13819 4.0795 7.26652 3.76451 7.07985 3.58367L5.45235 1.95617C5.34152 1.84534 5.15485 1.84534 5.04402 1.95617ZM9.33152 9.92451V6.41867C9.33152 6.09784 9.06902 5.83534 8.74819 5.83534C8.42735 5.83534 8.16485 6.09784 8.16485 6.41867V9.92451H7.12069C6.85819 9.92451 6.72985 10.2395 6.91652 10.4203L8.54402 12.042C8.66069 12.1528 8.84152 12.1528 8.95819 12.042L10.5857 10.4203C10.7724 10.2395 10.6382 9.92451 10.3815 9.92451H9.33152Z" fill="%23333333"/></svg>');
        }
      }
    }
  }

  // Count kutucukları (Count boxes)
  &__count {
    display: flex;
    align-items: center;
    min-width: 98px;
    height: 30px;
    gap: 4px;

    p {
      color: #333;
      text-align: center;
      font-feature-settings: 'liga' off, 'clig' off;
      font-family: Roboto;
      font-size: 14px !important;
      font-weight: 700 !important;
      line-height: 18px !important;
      margin-bottom: 0;
    }

    span {
      color: #333;
      font-family: Roboto;
      font-size: 12px;
      font-weight: 400;
      line-height: 18px;
    }

    i {
      font-size: 16px !important;
    }
  }

  &__count-content {
    display: flex;
    gap: 4px;
    padding: 4px 8px;
    align-items: center;
    justify-content: center;
    border-radius: 64px;
    border: 0.5px solid #D4D4D4;
    background: #FAFAFA;
  }

  &__count-border {
    display: flex;
    gap: 2px;
    padding: 1px 8px;
    align-items: center;
    justify-content: center;
    border-radius: 512px;
    border: 1px solid #E5E5E5;
    background: #FAFAFA;

    p {
      color: #878787 !important;
      /* Typography/Small Text/1 - Medium */
      font-family: Roboto;
      font-size: 12px !important;
      font-style: normal;
      font-weight: 500 !important;
      line-height: 18px !important;
    }

    i {
      color: #878787 !important;
      font-size: 14px !important;
    }
  }

  // Liste Öğesi (Item)
  &__item {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    padding: 16px 8px 16px 16px;
    background: #FFF;
    transition: all 0.3s ease-in-out;

    @media only screen and (max-width: 1150px) {
      position: relative;
    }

    &:last-child {
      border-radius: 0 0 8px 8px;
    }

    &:hover {
      background: #FAFAFA;

      .interview-list__item-actions {
        display: flex !important;
      }

      .assigned {
        .dropdown-toggle {
          outline-color: #FAFAFA !important;
        }
      }
      .assignees__evaluator,
      .show-more-button {
        border-color: #FAFAFA !important;
      }
    }

    p {
      color: #333;
      font-feature-settings: 'liga' off, 'clig' off;
      font-family: Roboto;
      font-size: 16px;
      font-weight: 500;
      line-height: 22px;
      margin-bottom: 0;
    }
  }

  // Liste Öğesi içeriği
  &__item-content {
    display: flex;
    align-items: center;
    gap: var(--Padding-4XLarge, 48px);

    @media only screen and (max-width: 1150px) {
      flex-direction: column;
      align-items: flex-start;
      flex: 1;
      gap: 8px;
    }
  }

  // Liste Öğesi Eylem Butonu
  &__item-actions {
    display: none;
    width: 36px;
    height: 36px;
    padding: 10px 8px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    border-radius: 100%;
    border: 1px solid transparent;
    background: transparent;
    transition: all 0.3s ease-in-out;
    z-index: 99;

    &:hover,
    &:has(.show) {
      border: 1px solid var(--Stroke-Colors-Secondary-Gray-Stroke, #D4D4D4);
      background: var(--Background-Colors-Primary-Gray, #EEE);
    }

    i {
      font-size: 16px;
    }

    @media only screen and (max-width: 1150px) {
      display: flex;
    }
  }

  &__item-type {
    width: fit-content;
    display: flex;
    align-items: center;
    gap: 2px;
    border-radius: 512px;
    border: 1px solid #E5E5E5;
    background: #FAFAFA;
    padding: 1px 8px;

    i {
      font-size: 14px;
      color: #878787;
    }

    p {
      color: #878787 !important;
      font-feature-settings: 'liga' off, 'clig' off;
      font-family: Roboto;
      font-size: 12px;
      font-weight: 500;
      line-height: 18px;
      margin: 0;
    }
  }

  &__status {
    display: flex;
    padding: 1px 8px;
    justify-content: center;
    align-items: center;
    gap: 2px;
    border-radius: 512px;
    transition: all 0.5s ease-in-out;

    p,
    span {
      font-family: Roboto;
      font-size: 12px;
      font-style: normal;
      font-weight: 500;
      line-height: 18px;
    }

    i {
      font-size: 14px;
    }

    &.completed {
      border: 1px solid #B6EAC9;
      background: #DBF4E4;

      p,
      span,
      i {
        color: #19552E;
      }
    }

    &.sent,
    &.incomplete {
      border: 1px solid #E5E5E5;
      background: #FAFAFA;

      p,
      i {
        color: #878787;
      }
    }

    &.scheduled {
      p,
      i {
        color: #878787;
        font-weight: 400 !important;
      }
    }

    &.expired {
      border: 1px solid #F2B5B5;
      background: #F8DADA;

      p,
      i {
        color: #631212;
      }
    }
  }

  // Analyze alanı stilleri
  &__analyze {
    display: flex;
    align-items: center;
    gap: var(--Padding-XSmall, 2px);

    &.label-button {
      display: flex;
      padding: 1px 8px;
      justify-content: center;
      align-items: center;
      gap: 2px;
      border-radius: 512px;
      border: 1px solid #E5E5E5;
      background: #FAFAFA;
    }

    p {
      color: #878787;
      font-feature-settings: 'liga' off, 'clig' off;
      font-family: Roboto;
      font-size: 12px;
      font-weight: 400;
      line-height: 18px;
      margin-bottom: 0;
    }

    i {
      color: #878787;
      font-size: 14px;
    }
  }
}

.border-button {
  display: flex;
  padding: 6px 16px;
  justify-content: center;
  align-items: center;
  border-radius: 114px;
  border: 1px solid #ff8d06;
  background: transparent !important;
  gap: 8px;
  min-width: 170px;

  color: var(--main-colors-orange, #ff8d06);
  text-align: center;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;
  transition: all 0.3s ease-in-out;

  &:hover {
    background: #FF8D06 !important;
    color: #fff !important;

    path {
      fill: #fff !important;
    }
  }

  &--checkbox {
    min-width: fit-content !important;
  }
}

.bg-button {
  display: flex;
  padding: 6px 16px;
  justify-content: center;
  align-items: center;
  border-radius: 114px;
  border: 1px solid #ff8d06;
  background: #ff8d06;
  gap: 8px;
  min-width: 170px;

  color: #fff;
  text-align: center;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;
  transition: all 0.3s ease-in-out;

  &:hover {
    background: #FF7415 !important;
  }
}

.modal-actions {
  width: calc(100% - 48px);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  align-self: stretch;
  padding: 0px 24px;
  margin: 0 auto;

  button {
    min-width: auto;
  }

}

.cst-modal-one {
  position: fixed;
  height: 100%;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background: rgba(29, 29, 29, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 4444;
  .cst-container {
    width: 392px;
    height: auto;
    background: #ffffff;
    border: 1px solid #e4e4e4;
    border-radius: 12px;
    padding: 0px;
    .cst-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 0px 24px 24px 24px;
    }
    .cst-header {
      width: 100%;
      height: 36px;
      justify-content: flex-end;
      cursor: pointer;
      display: flex;
      padding: 12px 12px 0px;
    }
    > :last-child {
      .cst-header {
        display: flex;
      }
    }
  }
}

.warning-area {
  word-wrap: break-word;
  width: 100%;
  &__head {
    font-family: "Roboto" !important;
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 26px;
    text-align: center;
    color: #353535;
    margin-top: 10px !important;
    margin-bottom: 8px !important;
  }
  &__note {
    font-family: "Roboto" !important;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    color: #858585;
    margin-bottom: 24px !important;
  }
}

::v-deep {
  .multiselect {
    width: 152px;
    height: 32px;
    min-height: 32px;
    z-index: 999;
  }

  .status-multiselect,
  .assigness-multiselect  {
    width: 119px !important;
    height: 32px;
    min-height: 32px;
    z-index: 999;
  }

  .multiselect--active {
    .multiselect__select {
      text-align: right;
      z-index: 1;
      transform: none;
      top: 0 !important;
    }

    .multiselect__placeholder {
      display: inline-block;
    }

    .multiselect__tags,
    .multiselect__single,
    .multiselect__placeholder {
      background: #EEE;
    }
  }

  .multiselect__select {
    height: 32px !important;
    min-height: 32px !important;
    padding: 6px 8px !important;
    top: 0;
    right: 0;
  }

  .multiselect__tags {
    height: 32px !important;
    min-height: 32px !important;
    padding: 6px 8px !important;
    border-radius: 40px;
    border: 1px solid #D4D4D4;
    background: #FFF;
    overflow: hidden;
    box-shadow: none;
    display: flex;
    align-items: center;

    &:has(.selected-option) {
      background: #EEE;

      .multiselect__single {
        background: #EEE;
      }
    }
  }

  .multiselect__single,
  .multiselect__placeholder {
    margin-bottom: 0;
    font-size: 12px !important;
    line-height: 18px;
    vertical-align: top;
  }

  .option__title {
    display: flex;
    align-items: center;
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    color: #333 !important;

    span {
      padding: 0 4px;
    }

    i {
      color: #333;
      font-size: 20px;
    }
  }
  .multiselect__content {
    box-shadow: none !important;
  }

  .assigness-multiselect {
    .multiselect__content-wrapper {
      width: 256px;
      max-height: 226px;
    }
  }

  .multiselect__content-wrapper {
    z-index: 999;
    top: 36px;
    padding: 4px 0;
    border-radius: 4px !important;
    border: 1px solid #E5E5E5;
    box-shadow: 0px 2px 12px 1px rgba(0, 0, 0, 0.12);
  }

  .multiselect__option {
    padding: 6px 8px !important;
    height: 32px;
    min-height: auto;
    display: flex;
    align-items: center;
    font-family: Roboto;
    font-size: 14px !important;
    font-style: normal;
    font-weight: 400 !important;
    line-height: 20px !important;
  }

  .multiselect__option--highlight {
    background: #EEE;
  }

  .multiselect__option--selected:after {
    display: none;
  }

  .multiselect__select:before {
    content:  url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M13.2292 7.49961L9.99583 10.7329L6.7625 7.49961C6.4375 7.17461 5.9125 7.17461 5.5875 7.49961C5.2625 7.82461 5.2625 8.34961 5.5875 8.67461L9.4125 12.4996C9.7375 12.8246 10.2625 12.8246 10.5875 12.4996L14.4125 8.67461C14.7375 8.34961 14.7375 7.82461 14.4125 7.49961C14.0875 7.18294 13.5542 7.17461 13.2292 7.49961Z" fill="%23333333"/></svg>') !important;
    border: none !important;
    top: 2% !important;
  }

  .multiselect__input {
    margin-bottom: 0px !important;
  }
}

.action-area {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 16px 16px 16px;
}

::v-deep .custom-control-input {
  &:checked {
    & ~ .custom-control-label {
      &::before {
        content: "\E9B7" !important;
        color: $white !important;
        background: $purple !important;
        font-size: 16px;
        text-align: center;
        position: absolute;
        left: -22px;
      }
    }
  }
}

.select-text {
  font-family: Roboto !important;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #333333;

  &--gray {
    color: #878787;
  }
}

.pulse-animation {
  animation: pulseAnimation 2s ease 0s infinite normal none;
}

@keyframes pulseAnimation {
  0%,
  50%,
  100% {
    opacity: 1;
  }

  25%,
  75% {
    opacity: 0;
  }
}

.sub-header {
  overflow-x: unset !important;
}

.add-candidate-area {
  display: flex;
  align-items: center;
  justify-content: center;
  @include border-radius(4px);
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  line-height: 18px;
  color: $white;
  text-transform: uppercase !important;
}

.show-mine-button {
  height: 30px;
  width: 30px;
  padding: 8px;
  justify-content: center;
  align-items: center;
  border-radius: 30px;
  border: 1px solid #FFEBCF;
  outline: 1px solid #FFEBCF;
  background: #FFEBCF;
  color: var(--Text-Colors-Primary-Gray-Text, #333);
  font-feature-settings: "liga" off, "clig" off;
  /* Typography/Small Text/1 - Medium */
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;

  &.active {
    border: 1px solid #FFF;
    outline: 1px solid #d4d4d4 !important;
  }
}

.assign-bulk-button {
  padding: 9px 8px;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  border: 1px solid #d4d4d4;
  background: #fff;
  transition: all 0.3s ease-in-out;
  cursor: pointer;

  &:hover {
    background: #E5E5E5;
    border: 1px solid #E5E5E5;
  }

  span {
    color: #333;
    text-align: center;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 18px;
    padding: 0 8px;
  }

  i {
    color: #333;
    font-size: 16px;
    margin-right: 0 !important;
  }
}

.assignees-tooltip {
  opacity: 1 !important;

  &.bs-tooltip-right {
    ::v-deep .arrow {
      &::before {
        border: 0 !important;
        background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="17" height="9" viewBox="0 0 17 9" fill="none"><path d="M17 9L0 9L7.04598 1.53956C7.83522 0.703886 9.16478 0.703887 9.95403 1.53956L17 9Z" fill="%23DBF0F9"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 9L0 9L7.04598 1.53956C7.83522 0.703886 9.16478 0.703887 9.95403 1.53956L17 9L15.5 9L14.6801 8L9.22701 2.22618C8.83239 1.80835 8.16761 1.80835 7.77299 2.22618L2.31993 8L1.5 9Z" fill="%23B7E1F3"/></svg>');
        width: 17px;
        height: 9px;
      }
    }
  }

  &.bs-tooltip-left {
    ::v-deep .arrow {
      &::before {
        border: 0 !important;
        background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="17" height="9" viewBox="0 0 17 9" fill="none"><path d="M17 9L0 9L7.04598 1.53956C7.83522 0.703886 9.16478 0.703887 9.95403 1.53956L17 9Z" fill="%23DBF0F9"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 9L0 9L7.04598 1.53956C7.83522 0.703886 9.16478 0.703887 9.95403 1.53956L17 9L15.5 9L14.6801 8L9.22701 2.22618C8.83239 1.80835 8.16761 1.80835 7.77299 2.22618L2.31993 8L1.5 9Z" fill="%23B7E1F3"/></svg>');
        width: 17px;
        height: 9px;
        transform: rotate(180deg);
      }
    }
  }

  &.bs-tooltip-bottom {
    padding: 0 !important;
    top: 10px !important;

    ::v-deep .arrow {
      &::before {
        border: 0 !important;
        background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="17" height="9" viewBox="0 0 17 9" fill="none"><path d="M17 9L0 9L7.04598 1.53956C7.83522 0.703886 9.16478 0.703887 9.95403 1.53956L17 9Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 9L0 9L7.04598 1.53956C7.83522 0.703886 9.16478 0.703887 9.95403 1.53956L17 9L15.5 9L14.6801 8L9.22701 2.22618C8.83239 1.80835 8.16761 1.80835 7.77299 2.22618L2.31993 8L1.5 9Z" fill="%23E5E5E5"/></svg>') !important;
        width: 17px;
        height: 9px;
        bottom: 5px;
      }
    }
  }

  ::v-deep .tooltip-inner {
    border: 1px solid var(--Stroke-Colors-Light-Blue-Stroke, #e5e5e5) !important;
    background: var(--Background-Colors-Light-Blue, #fff) !important;
    border-radius: 4px !important;
    padding: 8px 12px !important;
    width: fit-content !important;
    max-width: fit-content !important;
    box-shadow: 0px 2px 6px 0px rgba(176, 186, 197, 0.6) !important;

    text-align: left;
    color: var(--Text-Colors-Blue-Text, #333) !important;
    /* Typography/Small Text/1 - Regular */
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px; /* 150% */
  }
}

::v-deep {
  .add-candidate-area {
    &.show {
      .btn {
        background: #FF7415 !important;
      }
    }
  }
  #dropdown-left {
    .btn{
      display: flex;
      padding: 9px 8px;
      height: 36px;
      justify-content: center;
      align-items: center;
      border-radius: 40px;
      border: 1px solid #ff8d06;
      background: #ff8d06;
      transition: all 0.2s ease-in-out;

      span {
        color: #fff;
        text-align: center;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 18px;
        padding: 0 8px;
      }

      i {
        color: #fff;
        font-size: 16px;
        margin-right: 0 !important;
      }

      &.disabled {
        border-color: transparent;
      }

      &:hover {
        background: #FF7415;
      }

      &:after {
        content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10.5832 5.99969L7.99657 8.58635L5.4099 5.99969C5.1499 5.73969 4.7299 5.73969 4.4699 5.99969C4.2099 6.25969 4.2099 6.67969 4.4699 6.93969L7.5299 9.99969C7.7899 10.2597 8.2099 10.2597 8.4699 9.99969L11.5299 6.93969C11.7899 6.67969 11.7899 6.25969 11.5299 5.99969C11.2699 5.74635 10.8432 5.73969 10.5832 5.99969Z" fill="white"/></svg>');
        border: 0px !important;
        margin-left: 0;
        vertical-align: unset;
        position: relative;
        top: 2px;
      }
    }
    .dropdown-menu {
      &.show {
        border-radius: 4px !important;
      }

      @media only screen and (max-width: map-get($grid-breakpoints, "md")) {
        left: -20px !important;
      }
    }
    .dropdown-item {
      background-color: #ffffff !important;
      color: #333333 !important;
      text-transform: none !important;
      padding: 6px 8px !important;
      font-family: Roboto;
      font-size: 14px !important;
      font-style: normal;
      font-weight: 400 !important;
      line-height: 20px !important;
      border-radius: 0 !important;
      &:hover {
        background-color: #EEEEEE !important;
        color: #333333 !important;
      }
    }
  }
  .dropdown-menu {
    background-color: #ffffff !important;
    width: 100%;
    min-width: 100px;
    border-radius: 4px;
    border: 1px solid var(--Stroke-Colors-Primary-Gray-Stroke, #E5E5E5);
    box-shadow: 0px 2px 12px 1px rgba(0, 0, 0, 0.12);
    z-index: 9999 !important;
    padding: 4px 0;
  }
  .dropdown-item {
    color: #333333 !important;
    text-transform: capitalize;
    padding: 6px 8px !important;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    &:first-child{
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
    }
    &:last-child{
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
    }
    &:hover {
      background-color: #EEEEEE !important;
      color: #333333 !important;
    }
  }

  .new-modal {
    .modal-dialog {
      max-width: 446px;
    }
    .modal-content {
      border-radius: 12px;
    }

    .modal-header {
      border-bottom: 0;
      padding: 12px 12px 0px 12px;

      i {
        font-size: 24px;
        color: #333333;
      }
    }

    .modal-body {
      border-bottom: 0;
      padding: 0px 24px 24px 24px;

      img {
        margin-bottom: 14px;
      }

      h2 {
        color: #353535;
        text-align: center;
        font-feature-settings: "liga" off, "clig" off;
        font-family: Roboto;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: 26px;
        margin-bottom: 8px;
      }

      p {
        color: #858585;
        text-align: center;
        font-feature-settings: "liga" off, "clig" off;
        font-family: Roboto;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        margin-bottom: 24px;
      }
    }

    .border-button-create {
      display: flex;
      flex: 1;
      padding: 9px 16px;
      justify-content: center;
      align-items: center;
      border-radius: 114px;
      border: 1px solid #ff8d06;
      background: transparent !important;

      color: var(--main-colors-orange, #ff8d06);
      text-align: center;
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: 18px;
    }

    .bg-button {
      display: flex;
      flex: 1;
      padding: 9px 16px;
      justify-content: center;
      align-items: center;
      border-radius: 114px;
      border: 1px solid #ff8d06;
      background: #ff8d06;

      color: #fff;
      text-align: center;
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: 18px;
    }
  }
}
</style>
